import { RotatingLines } from "react-loader-spinner";

function PageLoader() {
  return (
    <div className="flex flex-1 w-full min-h-[50vh] items-center justify-center" role="status" aria-label="Loading">
      <RotatingLines strokeColor="#9333ea" strokeWidth="5" animationDuration="0.75" width="40" visible />
    </div>
  );
}

export { PageLoader };
